import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'my-12 w-full scroll-mt-[calc(var(--head-fixed-height-1,172px)+16px)] max-lg:scroll-mt-[calc(var(--head-fixed-height,64px)+16px)] max-md:scroll-mt-[calc(var(--head-fixed-height,48px)+16px)] lg:my-[100px] lg:px-1',
    activeComponents:
      'mt-3.5 max-w-271 text-black max-md:mb-5 lg:mt-6 lg:px-7.5',
    activeComponentsList:
      'grid list-disc gap-3 text-base leading-[1.7] font-light marker:text-[10px] lg:ml-7 lg:text-lg',
    composition: 'mt-3.5 max-w-271 text-black max-md:mb-5 lg:mt-6 lg:px-7.5',
    compositionText: 'text-base leading-[1.7] font-light lg:text-lg',
    compositionLink: 'mt-6 block no-underline',
    compositionButton: 'h-auto p-0',
    compositionButtonText: 'heading-xs flex items-center gap-2 font-semibold',
    usageInstructions: 'max-md:mb-5',
    certificates: 'mt-3.5 flex flex-wrap gap-3 lg:mt-6 lg:px-7.5'
  }
});
